// extracted by mini-css-extract-plugin
module.exports = {"container":"VNButtonContainer_container__W9o2D","buttonParent":"VNButtonContainer_buttonParent__2PPsv","containerButton":"VNButtonContainer_containerButton__3UzOh"};